'use strict';

exports.__esModule = true;

var _class, _temp, _initialiseProps;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _webSso = require('@vezeeta/web-sso');

var _mixpanelBrowser = require('mixpanel-browser');

var _mixpanelBrowser2 = _interopRequireDefault(_mixpanelBrowser);

var _reactMixpanel = require('react-mixpanel');

var _user = require('@vezeeta/enterprise-store/lib/actions/user');

var _country = require('@vezeeta/enterprise-store/lib/actions/country');

var _payment = require('@vezeeta/enterprise-store/lib/actions/payment');

var _webUtils = require('@vezeeta/web-utils');

var _webComponents = require('@vezeeta/web-components');

var _Integrations = require('./app/Integrations');

var _EnterpriseLayout = require('./EnterpriseLayout');

var _EnterpriseLayout2 = _interopRequireDefault(_EnterpriseLayout);

var _ClinicsContainer = require('./ClinicsContainer');

var _ClinicsContainer2 = _interopRequireDefault(_ClinicsContainer);

var _UserContainer = require('./UserContainer.helper');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UserContainer = (_temp = _class = function (_Component) {
  _inherits(UserContainer, _Component);

  function UserContainer(props) {
    _classCallCheck(this, UserContainer);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _initialiseProps.call(_this);

    if (_webUtils.Cookie.get(_webUtils.Cookie.AUTH_TOKEN)) {
      _this.accountKey = (0, _webUtils.decodeJwtToken)(_webUtils.Cookie.get(_webUtils.Cookie.AUTH_TOKEN)).payLoad.unique_name;
    }

    var language = void 0;
    if (_webUtils.Cookie.get(_webUtils.Cookie.LANGUAGE)) {
      language = _webUtils.Cookie.get(_webUtils.Cookie.LANGUAGE);
    } else {
      _webUtils.Cookie.set(_webUtils.Cookie.LANGUAGE, 'en');
      language = 'en';
    }

    _this.state = {
      user: undefined,
      userLoaded: false,
      userFirstName: undefined,
      userLastName: undefined,
      userEmail: undefined,
      userProfilePhotoPath: undefined,
      enableAddCreditCardOption: false,
      paymentTypeKey: undefined,
      entityKey: undefined,
      paymentDetailsState: undefined,
      cardsState: undefined,
      language: language
    };
    return _this;
  }

  UserContainer.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
    if (prevState.user !== nextProps.user && nextProps.userLoaded !== prevState.userLoaded) {
      (0, _Integrations.initSetUpMixpanel)(nextProps.user, prevState.language);
      (0, _Integrations.integrateRaygun)(nextProps.user);
      (0, _Integrations.integrateSalesforce)(nextProps.user, prevState.language);

      if (nextProps.user && nextProps.user.DefaultLanguageId) {
        var language = nextProps.user.DefaultLanguageId === 1 ? 'en' : 'ar';
        if (prevState.language !== language) {
          _webUtils.Cookie.set(_webUtils.Cookie.LANGUAGE, '' + (nextProps.user.DefaultLanguageId === 1 ? 'en' : 'ar'));
          window.location.reload();
        }
      }
      return {
        user: nextProps.user,
        userLoaded: nextProps.userLoaded,
        userFirstName: nextProps.user.FirstName,
        userLastName: nextProps.user.LastName,
        userEmail: nextProps.user.EmailAddress,
        userProfilePhotoPath: nextProps.user.ProfilePhotoPath,
        userCountryIsoCode: nextProps.user.CountryIsoCode,
        entityKey: nextProps.user.EntityKey
      };
    }

    if (prevState.paymentDetailsState !== nextProps.payment.paymentDetailsState && nextProps.payment.paymentDetailsState === _payment.PAYMENT.GET_PAYMENT_DETAILS.SUCCEEDED && nextProps.payment.paymentDetails) {
      return {
        paymentTypeKey: nextProps.payment.paymentDetails.PaymentTypeKey,
        enableAddCreditCardOption: (0, _UserContainer.shouldEnableAddCreditCardInfo)(nextProps.payment.cards, nextProps.payment.paymentDetails.PaymentMethodKey),
        paymentDetailsState: nextProps.payment.paymentDetailsState
      };
    }

    if (prevState.cardsState !== nextProps.payment.cardsState && nextProps.payment.cardsState === _payment.PAYMENT.GET_CREDIT_CARDS.SUCCEEDED && nextProps.payment.cards && nextProps.payment.paymentDetails) {
      return {
        enableAddCreditCardOption: (0, _UserContainer.shouldEnableAddCreditCardInfo)(nextProps.payment.cards, nextProps.payment.paymentDetails.PaymentMethodKey),
        cardsState: nextProps.payment.cardsState
      };
    }

    return null;
  };

  UserContainer.prototype.componentWillUnmount = function componentWillUnmount() {
    this.authTokenChecker = null;
  };

  UserContainer.prototype.render = function render() {
    var _props = this.props,
        supportSingleLanguage = _props.supportSingleLanguage,
        user = _props.user,
        extendContentContainer = _props.extendContentContainer;

    return _react2.default.createElement(
      _reactMixpanel.MixpanelProvider,
      { mixpanel: _mixpanelBrowser2.default },
      _react2.default.createElement(
        _webComponents.HttpsRedirection,
        { disableHttps: process.env.REACT_APP_FORCE_HTTPS === 'false' },
        _react2.default.createElement(
          _webSso.AuthContainer,
          { onAuthenticate: this.onAuthenticate },
          _react2.default.createElement(
            _ClinicsContainer2.default,
            { language: this.state.language },
            _react2.default.createElement(
              _EnterpriseLayout2.default,
              {
                loading: !this.props.userLoaded,
                doctorName: this.state.userFirstName + ' ' + this.state.userLastName,
                doctorEmail: this.state.userEmail,
                doctorPhoto: this.state.userProfilePhotoPath,
                tabs: this.props.headerTabs,
                title: this.props.title,
                breadcrumbProps: this.props.breadcrumbProps,
                activeTab: this.props.activeTab,
                enablePayLater: !this.state.enableAddCreditCardOption,
                payLater: this.goToCartInAccountsWeb,
                manageBranches: this.goToProducts,
                subsciptions: this.goToSubscriptions,
                signOut: _webSso.signOut,
                env: process.env.REACT_APP_CONFIG_ENV,
                cdnUrl: process.env.REACT_APP_CDN_URL,
                language: this.state.language,
                onLanguageChange: this.onLanguageChange,
                mixpanel: _mixpanelBrowser2.default,
                supportSingleLanguage: supportSingleLanguage,
                user: user,
                extendContentContainer: extendContentContainer
              },
              _react2.default.createElement(
                _Integrations.AppError,
                null,
                _react2.default.createElement(
                  'div',
                  { className: 'App' },
                  this.props.children
                )
              )
            )
          )
        )
      )
    );
  };

  return UserContainer;
}(_react.Component), _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.componentDidMount = function () {
    _this2.authTokenChecker = setInterval(function () {
      return _this2.pollAuthTokenChecker();
    }, 3000);
  };

  this.onLanguageChange = function (language) {
    _webUtils.Cookie.set(_webUtils.Cookie.CULTURE, (language === 'en' ? 'ar' : 'en') + '-' + _this2.props.user.CountryIsoCode);
    _mixpanelBrowser2.default.track('Changed Language', {
      'Changed to': language === 'en' ? 'ar' : 'en'
    });
    _this2.props.setUserDefaultLangauge(language === 'en' ? 2 : 1, true);
  };

  this.onAuthenticate = function () {
    if (!_this2.props.user) {
      var language = _this2.state.language;

      _this2.props.loadCountryList();
      _this2.props.loadCountry();
      _this2.props.getUser(language);
      _this2.props.loadAccountPaymentDetails(_this2.accountKey);
      _this2.props.loadAccountCreditCards(_this2.accountKey, true, _payment.STATUS.ACTIVE);
    }
  };

  this.pollAuthTokenChecker = function () {
    if (_this2.accountKey) {
      if (_webUtils.Cookie.get(_webUtils.Cookie.AUTH_TOKEN)) {
        if (_this2.accountKey !== (0, _webUtils.decodeJwtToken)(_webUtils.Cookie.get(_webUtils.Cookie.AUTH_TOKEN)).payLoad.unique_name) {
          window.location.reload();
        }
      } else {
        window.location.reload();
      }
    }
  };

  this.goToCartInAccountsWeb = function () {
    var _state = _this2.state,
        entityKey = _state.entityKey,
        paymentTypeKey = _state.paymentTypeKey;

    var cookieExpiryTime = parseInt(process.env.REACT_APP_TEMP_COOKIE_EXPIRY_MINUTES) / 60 / 24;
    var cookieExpiryTimeInMillisecond = cookieExpiryTime * 24 * 3600 * 1000;
    // Adding cookies for accounts.vezeeta.com
    _webUtils.Cookie.set(_webUtils.Cookie.ACCOUNT_KEY, (0, _webUtils.encrypt)(_this2.accountKey), { expires: cookieExpiryTime });
    _webUtils.Cookie.set(_webUtils.Cookie.CLINIC_KEY, (0, _webUtils.encrypt)(entityKey), { expires: cookieExpiryTime });
    _webUtils.Cookie.set(_webUtils.Cookie.START_ROUTE, '/cart', { expires: cookieExpiryTime });
    _webUtils.Cookie.set(_webUtils.Cookie.END_ROUTE, '/confirmation', { expires: cookieExpiryTime });
    _webUtils.Cookie.set(_webUtils.Cookie.RETURN_URL, window.location.href, { expires: cookieExpiryTime });
    _webUtils.Cookie.set(_webUtils.Cookie.PAGE_TITLE, 'Add credit card info', { expires: cookieExpiryTime });
    _webUtils.Cookie.set(_webUtils.Cookie.PAYMENT_TYPE_KEY, (0, _webUtils.encrypt)(paymentTypeKey), {
      expires: cookieExpiryTime
    });
    _webUtils.Cookie.set(_webUtils.Cookie.EXPIRY_TIME, Date.now() + cookieExpiryTimeInMillisecond, {
      expires: cookieExpiryTime
    });

    window.location.replace(process.env.REACT_APP_ACCOUNTS_URL + '/en-' + _this2.state.userCountryIsoCode.toLowerCase() + '/signup/cart');
  };

  this.goToProducts = function () {
    var entityKey = _this2.state.entityKey;

    var cookieExpiryTime = 10 / 60 / 24;
    var cookieExpiryTimeInMilliseconds = cookieExpiryTime * 24 * 3600 * 1000;
    // Adding cookies for accounts.vezeeta.com
    _webUtils.Cookie.set(_webUtils.Cookie.ACCOUNT_KEY, (0, _webUtils.encrypt)(_this2.accountKey), { expires: cookieExpiryTime });
    _webUtils.Cookie.set(_webUtils.Cookie.CLINIC_KEY, (0, _webUtils.encrypt)(entityKey), { expires: cookieExpiryTime });
    _webUtils.Cookie.set(_webUtils.Cookie.START_ROUTE, '/products', { expires: cookieExpiryTime });
    _webUtils.Cookie.set(_webUtils.Cookie.END_ROUTE, '/cart', { expires: cookieExpiryTime });
    _webUtils.Cookie.set(_webUtils.Cookie.RETURN_URL, window.location.href, { expires: cookieExpiryTime });
    _webUtils.Cookie.set(_webUtils.Cookie.PAGE_TITLE, 'Add Branches/Rooms | Vezeeta', { expires: cookieExpiryTime });
    _webUtils.Cookie.set(_webUtils.Cookie.EXPIRY_TIME, Date.now() + cookieExpiryTimeInMilliseconds, {
      expires: cookieExpiryTime
    });

    window.location.replace(
    // $FlowIgnore: suppressing this error
    process.env.REACT_APP_ACCOUNTS_URL.toString() + '/en-' + _this2.state.userCountryIsoCode.toLowerCase() + '/signup/products/book');
  };

  this.goToSubscriptions = function () {
    var entityKey = _this2.state.entityKey;
    // Adding cookies for accounts.vezeeta.com

    _webUtils.Cookie.set(_webUtils.Cookie.ACCOUNT_KEY, (0, _webUtils.encrypt)(_this2.accountKey));
    _webUtils.Cookie.set(_webUtils.Cookie.CLINIC_KEY, (0, _webUtils.encrypt)(entityKey));
    _webUtils.Cookie.set(_webUtils.Cookie.RETURN_URL, window.location.href);
    _webUtils.Cookie.set(_webUtils.Cookie.PAGE_TITLE, 'Subscription | Vezeeta');
    _webUtils.Cookie.set(_webUtils.Cookie.START_ROUTE, '/subscriptions');
    _webUtils.Cookie.set(_webUtils.Cookie.END_ROUTE, '/subscriptions');
    window.location = process.env.REACT_APP_ACCOUNTS_URL.toString() + '/subscriptions';
  };
}, _temp);


UserContainer.propTypes = process.env.NODE_ENV !== "production" ? {
  user: _propTypes2.default.object,
  userLoaded: _propTypes2.default.bool,
  payment: _propTypes2.default.object,
  getUser: _propTypes2.default.func.isRequired,
  loadCountry: _propTypes2.default.func.isRequired,
  loadCountryList: _propTypes2.default.func.isRequired,
  loadAccountPaymentDetails: _propTypes2.default.func.isRequired,
  loadAccountCreditCards: _propTypes2.default.func.isRequired,
  children: _propTypes2.default.object.isRequired,
  headerTabs: _propTypes2.default.array,
  activeTab: _propTypes2.default.string,
  title: _propTypes2.default.string,
  breadcrumbProps: _propTypes2.default.object,
  setUserDefaultLangauge: _propTypes2.default.func.isRequired,
  supportSingleLanguage: _propTypes2.default.bool,
  extendContentContainer: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.array])
} : {};

UserContainer.defaultProps = {
  user: undefined,
  userLoaded: false,
  payment: undefined,
  headerTabs: [],
  activeTab: undefined,
  title: undefined,
  breadcrumbProps: undefined
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    userLoaded: state.user.loaded,
    user: state.user.user,
    countryLoaded: state.country.loaded,
    payment: state.payment
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    getUser: function getUser(language) {
      return dispatch((0, _user.getUser)(language));
    },
    signOut: function signOut() {
      return dispatch((0, _webSso.signOut)());
    },
    loadCountryList: function loadCountryList() {
      return dispatch((0, _country.loadCountryList)());
    },
    loadCountry: function loadCountry() {
      return dispatch((0, _country.loadCountry)());
    },
    setUserDefaultLangauge: function setUserDefaultLangauge(languageId, reload) {
      return dispatch((0, _user.setUserDefaultLangauge)(languageId, reload));
    },
    loadAccountPaymentDetails: function loadAccountPaymentDetails(accountKey) {
      return dispatch((0, _payment.loadAccountPaymentDetails)(accountKey));
    },
    loadAccountCreditCards: function loadAccountCreditCards(accountKey, isActive, status) {
      return dispatch((0, _payment.loadAccountCreditCards)(accountKey, isActive, status));
    }
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(UserContainer);
module.exports = exports['default'];